import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import DropdownBox from '../../components/Dropdown/DropdownBox/DropdownBox';
import Option from '../../components/Dropdown/DropdownOption/DropdownOption';
import { messages } from '../../constants/MyStations';

export const ListItemSortDropdownKey = Symbol('ListItemSortDropdown');

class ListItemSortDropdown extends React.Component {
  static propTypes = {
    childProps: PropTypes.shape({
      onSortClicked: PropTypes.func,
      sortTypes: PropTypes.object,
    }),
    dropdownType: PropTypes.any,
    closeDropdown: PropTypes.func,
    intl: PropTypes.object,
  };

  render() {
    const settings = [];
    this.props.childProps.sortTypes.keySeq().forEach(sortType => {
      settings.push({
        label: <FormattedMessage {...messages[sortType]} />,
        callback: () => this.props.childProps.onSortClicked(sortType),
        isSelected: !!this.props.childProps.sortTypes.get(sortType),
      });
    }, this);
    const options = settings.map(({ label, callback, isSelected }, i) => {
      const optionProps = {
        callback,
        label,
        key: `option${i}`,
        isSelected,
        isSelectable: true,
        closeDropdown: this.props.closeDropdown,
        extrasStyles: ['Dropdown__stationSorter'],
      };

      return <Option key={i} {...optionProps} />;
    });
    return <DropdownBox menuType={this.props.dropdownType}>{options}</DropdownBox>;
  }
}

export const constructors = {
  [ListItemSortDropdownKey]: ListItemSortDropdown,
};
